/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useContext, useEffect, useState } from "react";
import { useAuth } from "cms/auth/hooks/use-auth";
import { isArrayNotEmpty } from "utils/empty-exists";
import { ContentZoneContext } from "cms/components/context";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";
import { NavCardsSectionItem } from "./section_item";
import { useWebpageSDK } from "cms/components/hooks/use-webpage-sdk";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";
import { isRichTextEmpty } from "cms/rich-text/richtext-utils";
import SimpliCityAdminSDK from "@simplicitycms/simplicity-admin-js-sdk";

const NavCardsSection = (props) => {
    
    const webpage_guid = props?.webpage_guid; // is webpage.guid
    const { token } = useAuth();
    const { component } = useContext(ContentZoneContext);
    const { fetchWebpageChildren } = useWebpageSDK();
    
    const [children, setChildren] = useState(null);
    const [error, setError] = useState(null);
    const description = component?.description;
    
    useEffect(() => {
        const executeAsync = async () => {
            const response = await fetchWebpageChildren(token, webpage_guid);
            const webpage = response?.webpage;
            const children = webpage?.children;
            const error = response?.error;
            setError(error);
            if (children && children.length > 0) {
                const enhancedChildren = await Promise.all(
                    children.map(async (child) => {
                        try {
                            const childGuid = child?.guid;
                            const banner_image = await SimpliCityAdminSDK.webpage.getWebpageBannerImage(token, childGuid);

                            return {
                                ...child,
                                banner_image: banner_image || null
                            };
                        } catch (error) {
                            return {
                                ...child,
                                banner_image: null
                            };
                        }
                    })
                );

                setChildren(enhancedChildren);
            } else {
                setChildren(children);
            }
        };

        executeAsync();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, webpage_guid]);
    
  
    const hasContent = isArrayNotEmpty(children);
    const noChildrenMessage = "This page currently has no children.";
    
    return (
        <>
            <EmptyContentMessage
                hasContent={hasContent}
                component={component}
                message={noChildrenMessage}
            />
            {!error && children &&
                <div className='simplicity-section-list'>
                    <div className='simplicity-section-description'>
                        {!isRichTextEmpty(description) &&
                            <RichTextPreview richtext={description} />
                        }
                    </div>
                    <div className='simplicity-section-list-body'>
                        {children.map((item, index) => {
                            return (
                                <NavCardsSectionItem
                                    key={index}
                                    item={item}
                                />
                            );
                        })}
                    </div>
                </div>
            }
            {error && <div className='error'>{error?.message}</div>}
            {/*{error && <div className='error'>{JSON.stringify(error)}</div>}*/}
        </>
    );
};

export { NavCardsSection }; 
